import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export function LandingCtaSection() {
  return (
    <section className="relative overflow-hidden border-t border-black/8 px-4 py-12 sm:px-6 sm:py-14 lg:px-8 lg:py-16">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(239,215,200,0.46),rgba(255,255,255,0)_52%)]" />

      <div className="relative mx-auto max-w-4xl text-center">
        <p className="text-[11px] font-semibold tracking-[0.18em] text-[#7f7468] uppercase">
          Start now
        </p>

        <h2 className="mt-4 text-[2.8rem] leading-[0.9] font-semibold tracking-[-0.05em] text-black sm:text-[4rem]">
          Keep the inspiration. Lose the chaos.
        </h2>

        <p className="mx-auto mt-5 max-w-2xl text-[15px] leading-7 text-[#5f564b] sm:text-base">
          Turn reels into real recipes, and decide dinner, together.
        </p>

        <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Button
            asChild
            size="lg"
            className="group h-12 bg-[#111111] px-6 text-sm text-white hover:bg-black"
          >
            <Link href="/account/signup">
              Start free
              <ArrowRight className="transition-transform duration-300 group-hover:translate-x-0.5" />
            </Link>
          </Button>

          <Button
            asChild
            size="lg"
            variant="ghost"
            className="h-12 px-6 text-sm text-[#5f564b] hover:bg-black/[0.03] hover:text-black"
          >
            <Link href="/account/login">Sign in</Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
